module.exports = __webpack_public_path__ + "assets/img/ava2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/testimonials/ava2.png
// module id = 1987
// module chunks = 0